import { property } from "lit/decorators.js";
import { LeafElement } from "../leaf-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class LeafSelectOption extends LeafElement {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.selected = false;
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(value) {
    const oldValue = this._value;
    this._value = value;
    if (oldValue.length && oldValue !== value) {
      this.emit("leaf:select-option-change");
    }
  }
}
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafSelectOption.prototype, "disabled", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafSelectOption.prototype, "selected", 2);
__decorateClass([
  property({ type: String })
], LeafSelectOption.prototype, "value", 1);
export {
  LeafSelectOption
};
//# sourceMappingURL=select-option.component.js.map
